import { Button, ButtonGroup, Flex } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ArrowRight } from '@/client/components/icons/ContinuIcons';
import OutlineButton from '@/client/components/shared/buttons/OutlineButton';
import SolidButton from '@/client/components/shared/buttons/SolidButton';
import WorkflowPublishModal from '../../overlay/WorkflowPublishModal';
import { useAdminAssignmentsStore } from '../../state/adminAssignmentsStore';
import { useCreateAndUpdateWorkflow } from '../hooks/useCreateAndUpdateWorkflow';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useValidateAssignment } from '../hooks/useValidateAssignment';

export default function AssignmentBuilderBottomControls() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { updateWorkflowMutation } = useCreateAndUpdateWorkflow();
  const { stepIndex, steps, setStepIndex, setCanLeave } = useAdminAssignmentsStore();
  const { validateCurrentForm } = useValidateAssignment();

  const isInstanceCreation =
    location.pathname.includes('instance') && location.pathname.includes('create');
  const isInstanceEdit =
    location.pathname.includes('instance') && location.pathname.includes('edit');

  const [publishModalIsOpen, setPublishModalIsOpen] = useState(false);

  return (
    <Flex
      zIndex={888}
      background="white"
      borderTop="1px solid"
      borderTopColor="warmNeutral.200"
      paddingY={4}
      paddingX={18}
      justifyContent="space-between"
    >
      <Button variant="createCancel" onClick={() => navigate('/admin/assignments/overview')}>
        {t('admin.assignments.controls.cancel')}
      </Button>

      <ButtonGroup>
        <OutlineButton isDisabled={stepIndex === 0} onClick={() => setStepIndex(stepIndex - 1)}>
          {t('admin.assignments.controls.previous')}
        </OutlineButton>

        {stepIndex !== steps.length - 1 && (
          <SolidButton
            rightIcon={<ArrowRight />}
            isDisabled={stepIndex === steps.length - 1}
            onClick={validateCurrentForm}
          >
            {t('admin.assignments.controls.next')}
          </SolidButton>
        )}

        {stepIndex === steps.length - 1 && !id && (
          <SolidButton onClick={() => setPublishModalIsOpen(true)}>
            {isInstanceCreation
              ? t('admin.assignments.instances.create')
              : t('admin.assignments.publish')}
          </SolidButton>
        )}

        {stepIndex === steps.length - 1 && id && (
          <SolidButton
            onClick={() => {
              if (isInstanceEdit) {
                setPublishModalIsOpen(true);

                return;
              }

              setCanLeave(true);

              updateWorkflowMutation.mutateAsync();
            }}
          >
            {t('admin.assignments.update')}
          </SolidButton>
        )}
      </ButtonGroup>

      <WorkflowPublishModal
        isOpen={publishModalIsOpen}
        onClose={() => setPublishModalIsOpen(false)}
      />
    </Flex>
  );
}
